module.exports = __webpack_public_path__ + "static/img/andBtn.1a6366d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/andBtn.png
// module id = VFwW
// module chunks = 3